var SvgIcon       = require("app/ui/SvgIcon"),
    frameThrottle = require("enyo-perf/utils").frameThrottle,
    icons         = require("app/theme/icons"),
    kind          = require("enyo/kind");

require("./PodcastRow.less");

module.exports = kind(/** @lends  app.PodcastPage.PodcastRow.prototype */ {

    /**
     * @private
     */
    name: "app.PodcastPage.PodcastRow",

    /**
     * @private
     */
    classes: "app-podcast-page-podcast-row",

    /**
     * The dataset
     *
     * @type  {?Object}
     * @public
     */
    data: null,

    /**
     * @private
     */
    components: [{
        name:    "title",
        tag:     "h2",
        classes: "app-podcast-page-podcast-row__title"
    }, {
        name:    "icon",
        classes: "app-podcast-page-podcast-row__icon",
        kind:    SvgIcon,
        icon:    icons["app.PodcastPage.PodcastRow.icon"],
        theme:   "media-row"
    }],

    /**
     * @private
     */
    observers: {
        update: ["data"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * Update the component in response to state changes.
     *
     * @public
     */
    update: function() {
        var $i18nService = this.app.$.i18nService;

        this.$.title.set("content", $i18nService.getString("app.PodcastPage.PodcastRow.Title"));
    }

});
